<template>
  <div class="slide-progress-box show-flex-box-r">
    <div class="slide-progress-content">
      <!-- 进度条 strong -->
      <strong></strong> 
      <!-- 圆形拖动 -->
      <span>
        <em>{{showNumber}}</em>
      </span>
      <!-- 鼠标移动竖线 -->
      <em></em>
    </div>
  </div>
</template>

<script>

export default {
  name: 'slideProgress',
  props: {
    slidePercentNumber: [Number,String],
    initSlidePercent:[Number,String],
    fullStatus: [Boolean]
  },
  data () {
    return {
      progressLeft: 0,
      progressWidth: 0,
      dragWidth: 0,
      showStatus: true,
      showNumber: 0,
      zoomSize: 0.9,  // html：zoom设置为了0.9
    }
  },
  mounted() {
    this.bindMouseEvent();
    this.setProgressDomInfo();
    this.initProgressStyleInfo();
  },
  methods: {
    setProgressDomInfo: function() {
      var htmlZoom = $('html').css("zoom");
      var domInfo = this.getProgressDomInfo();

      this.zoomSize = parseFloat(htmlZoom);
      this.progressLeft = domInfo.left * this.zoomSize;
      this.progressWidth = domInfo.width;
      this.dragWidth = $(".slide-progress-content>span").width();
    },
    initProgressStyleInfo: function() {
      this.showNumber = this.slidePercentNumber || 0;
      this.slidePercentNumber = this.showNumber;
      this.setSlideProgressByPercent()
    },
    getProgressDomInfo: function(key) {
      // {top: 349, left: 51}
      var offsetInfo = $('.slide-progress-box').offset();
      var w = $('.slide-progress-box').width();
      var h = $('.slide-progress-box').height();
      offsetInfo.width = w;
      offsetInfo.height = h;

      return key ? offsetInfo[key] : offsetInfo;
    },
    // 鼠标事件 start
    bindMouseEvent: function() {
      var _this = this;
      var dragStatus = false;

      $(".slide-progress-box").mouseover(function() {
        _this.setProgressDomInfo();
      })

      $(".slide-progress-content>span").mousedown(function(e) {
        dragStatus = true;
      })

      $(".slide-progress-content").mousemove(function(e) {
        if (!dragStatus) {
          return;
        }

        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;
        left = left / _this.zoomSize;

        _this.setDragInfoByMouseLeft(left);
        _this.setProgressWidthByLeft(left);
        _this.setPlayPercentByLeft(left);
      })

      $(".slide-progress-content>span").mouseleave(function(e) {
        dragStatus = false;
      })

      $(".slide-progress-box").click(function(e) {
        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;

        left = left / _this.zoomSize;

        _this.setDragInfoByMouseLeft(left);
        _this.setProgressWidthByLeft(left);
        _this.setPlayPercentByLeft(left);
      })

      $(".slide-progress-content>span").mouseup(function(e) {
        window.event? window.event.cancelBubble = true : e.stopPropagation();
        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;
        dragStatus = false;
        left = left / _this.zoomSize;

        _this.setPlayPercentByLeft(left);
      })
    },
    // 鼠标事件 end
    // 设置dom显示信息 start
    setPlayPercentByLeft: function(left) {
      var totalW = this.progressWidth;
      var leftNum = left / totalW;
      var point = leftNum.toFixed(3);
      
      point = point >= 0.995 ? 1 : point;

      this.showNumber = parseInt(point * 100);
      this.$emit('setSlidePogress', point);
    },
    setSlideProgressByPercent: function() {
      if (this.slidePercentNumber <= 0) {
        return;
      }
      var left = parseInt(this.progressWidth * this.slidePercentNumber);

      if (left > 0) {
        left = left / this.zoomSize;
        this.setProgressWidthByLeft(left);
        this.setDragInfoByMouseLeft(left);
      }
    },
    setDragInfoByMouseLeft: function(mouseLeft) {
      var dragW = this.dragWidth;
      var maxW = this.progressWidth - dragW;
      var left = mouseLeft - dragW / 2;
      var moveLeft = left > 0 ? left : 0;
      var showLeft = moveLeft > maxW ? maxW : moveLeft;

      this.setDragLocation(showLeft);
    },
    setProgressWidthByLeft: function(mouseLeft) {
      var dragW = this.dragWidth;
      var maxW = this.progressWidth - dragW;
      var left = mouseLeft;
      var moveLeft = left > 0 ? left : 0;
      var showLeft = moveLeft > maxW ? maxW : moveLeft;

      this.setProgressWidth(showLeft);
    },
    setProgressWidth: function(width) {
      $(".slide-progress-content>strong").css({
        'width': width
      })
    },
    setMouseReferLineLocation: function(left) {
      $(".slide-progress-content>em").css({
        'left': left + 'px'
      })
    },
    setDragLocation: function(left) {
      $(".slide-progress-content>span").css({
        'left': left + 'px'
      })
    }
    // 设置dom显示信息 end
  },
  watch: {
    fullStatus: function() {
      var _this = this;
      setTimeout(function() {
        _this.setProgressDomInfo();
      }, 300)
    }
  }
}
</script>
<style lang="less" scoped>
  .slide-progress-box {
    width: 100%;
    height: 5px;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    .slide-progress-content {
      position: relative;
      align-self: flex-end;
      width: 100%;
      // height: 6px;
      height: 100%;
      transition: height 0.3s ease;
      background: #fff;
      &>strong, &>span {
        display: block;
      }
      &>strong {
        // width: 0%;
        width: 0;
        height: 100%;
        background: #FF8B2E;
      }
      &>span {
        position: absolute;
        top: -6px;
        width: 18px;
        height: 18px;
        transition: opacity 0.3s ease;
        border-radius: 18px;
        background: #FF8B2E;
        z-index: 9;
        opacity: 1;
        cursor: pointer;
        &>em {
          display: none;
          position: absolute;
          top: -25px;
          height: 18px;
          padding: 1px 3px;
          font-size: 12px;
          text-align: center;
          line-height: 18px;
          border-radius: 3px;
          font-style: normal;
          background: #FF8B2E;
          color: #fff;
          z-index: 99;
        }
      }
      &>span:hover {
        &>em {
          display: block;
        }
      }
      &>em {
        display: none;
        position: absolute;
        top: 0;
        // left: 50%;
        width: 1px;
        height: 100%;
        z-index: 8;
        background: #000;
      }
    }
  }
  // .slide-progress-box:hover {
  //   .slide-progress-content {
  //     height: 100%;
  //      &>span { 
  //         opacity: 1;
  //      }
  //      &>em {
  //        display: block;
  //      }
  //   }
  // }
  // .el-progress-box {
  //   width: 100%;
  // }
</style>



// WEBPACK FOOTER //
// src/components/common/slide_progress_cpn.vue